/* eslint-disable */
import * as types from '../../actions/types';

const initialState = null

export default function statistic (state = initialState, action) {
  switch (action.type) {
    
    case types.SET_TESTING_STATISTIC:
      return action.payload
    
    default:
      return state;
  }
}